import React, { useState, useEffect, useMemo } from 'react';
import { Layout as AntLayout, Menu, Avatar, Dropdown, Button, theme, Breadcrumb, Space } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  DashboardOutlined,
  AppstoreOutlined,
  ExperimentOutlined,
  DatabaseOutlined,
  SettingOutlined,
  UserOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  BulbOutlined,
  FileTextOutlined,
  BarChartOutlined,
  TagsOutlined,
  RollbackOutlined,
  CloudOutlined,
  CloudUploadOutlined,
  FileDoneOutlined,
  ThunderboltOutlined,
  LineChartOutlined
} from '@ant-design/icons';
import { userApi } from '../../services/api';
import { useWorkspace } from '../../contexts/WorkspaceContext';

const { Header, Sider, Content } = AntLayout;

// 基础菜单项（始终显示）
const baseMenuItems = [
  {
    key: '/dashboard',
    icon: <DashboardOutlined />,
    label: '工作台',
  },
  {
    key: 'domain-management',
    icon: <AppstoreOutlined />,
    label: '域管理',
    children: [
      {
        key: '/business-domain',
        icon: <BulbOutlined />,
        label: '项目空间管理',
      },
    ],
  },
];

// 业务场景菜单项（进入项目空间后显示）
const scenarioMenuItem = {
  key: '/business-scenario',
  icon: <ExperimentOutlined />,
  label: '业务场景管理',
};



function Layout({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const [currentUser, setCurrentUser] = useState({
      name: '管理员',
      workid: 'admin',
      headImg: ''
    });
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = theme.useToken();
  const { currentDomain, currentScenario, exitDomain, exitScenario } = useWorkspace();

  // 根据当前状态动态生成菜单
  const menuItems = useMemo(() => {
    // 影子链路菜单（始终显示）
    const shadowLinkMenu = {
      key: 'shadow-link',
      icon: <CloudOutlined />,
      label: '影子链路',
      children: [
        {
          key: '/shadow-link/assertion-config',
          icon: <ThunderboltOutlined />,
          label: '断言配置',
        },
        {
          key: '/shadow-link/report',
          icon: <CloudUploadOutlined />,
          label: '影子上报',
        },
        {
          key: '/shadow-link/evaluation',
          icon: <FileDoneOutlined />,
          label: '评测报告',
        },
      ],
    };

    // 如果没有进入项目空间，只显示工作台、项目空间管理和影子链路
    if (!currentDomain) {
      return [
        {
          key: '/dashboard',
          icon: <DashboardOutlined />,
          label: '工作台',
        },
        {
          key: '/business-domain',
          icon: <AppstoreOutlined />,
          label: '项目空间管理',
        },
        shadowLinkMenu,
        {
          key: '/data-insight',
          icon: <LineChartOutlined />,
          label: '评测数据洞察',
        },
      ];
    }

    // 进入了项目空间，构建域管理子菜单
    const domainChildren = [
      {
        key: '/business-domain',
        icon: <BulbOutlined />,
        label: '项目空间管理',
      },
      {
        key: '/business-scenario',
        icon: <ExperimentOutlined />,
        label: '业务场景管理',
      },
    ];

    // 如果进入了业务场景，将评测相关菜单添加到域管理下（与业务场景管理平级）
    if (currentScenario) {
      domainChildren.push(
        {
          key: '/judge-set',
          icon: <FileTextOutlined />,
          label: '评测集管理',
        },
        {
          key: '/use-case',
          icon: <TagsOutlined />,
          label: '用例管理',
        },
        {
          key: '/judge-scenario',
          icon: <SettingOutlined />,
          label: '评测场景配置',
        },
        {
          key: '/judge-task',
          icon: <ExperimentOutlined />,
          label: '评测任务管理',
        },
        {
          key: '/benchmark',
          icon: <BarChartOutlined />,
          label: 'Benchmark管理',
        }
      );
    }

    const items = [
      {
        key: '/dashboard',
        icon: <DashboardOutlined />,
        label: '工作台',
      },
      {
        key: 'domain-management',
        icon: <AppstoreOutlined />,
        label: '域管理',
        children: domainChildren,
      },
      shadowLinkMenu,
      {
        key: '/data-insight',
        icon: <LineChartOutlined />,
        label: '评测数据洞察',
      },
    ];

    return items;
  }, [currentDomain, currentScenario]);

  // 获取当前用户信息
  useEffect(() => {
    fetchUserInfo();
  }, []);

//   //获取当前用户信息
//   const ONEDAY_CONFIG = window.ONEDAY_CONFIG || window.parent?.window?.ONEDAY_CONFIG;
//   const currentUser = ONEDAY_CONFIG?.user || {
//     name: '管理员',
//     workid: 'admin',
//     headImg: ''
//   };

  //查询管理员信息
    const fetchUserInfo = async () => {
      try {
        // 假设用户信息接口为 /api/user/info
        const userInfo = await userApi.getUserInfo();
        setCurrentUser({
                  name: userInfo.nickName || userInfo.empName || '管理员',
                  workid: userInfo.workNo || 'admin',
                  headImg: ''
        });
      } catch (error) {
        console.error('获取用户信息失败:', error);
        message.error('获取用户信息失败');
      }
    };

 //退出登陆
  const handleUserMenuClick = async ({ key }) => {
    if (key === 'logout') {
      try {
        // 调用退出登录接口
        const loginUrl = await userApi.logoutAdminUser();
        console.log('loginUrl------->', loginUrl);
        // 跳转到登录页或刷新页面
        window.location.href = loginUrl; // 假设有登录页面
      } catch (error) {
        console.error('退出登录失败:', error);
        message.error('退出登录失败');
      }
    }
  };


  const handleMenuClick = ({ key }) => {
    if (key.startsWith('/')) {
      // 如果点击工作台，退出项目空间和业务场景
      if (key === '/dashboard') {
        if (currentDomain) {
          exitDomain();
        }
      }
      // 如果点击项目空间管理菜单，退出项目空间和业务场景
      else if (key === '/business-domain') {
        if (currentDomain) {
          exitDomain();
        }
      }
      // 如果点击业务场景管理菜单，且当前在业务场景内，则自动退出业务场景
      else if (key === '/business-scenario' && currentScenario) {
        exitScenario();
      }
      navigate(key);
    }
  };

  // 处理退出操作
  const handleExitScenario = () => {
    exitScenario();
    navigate('/business-scenario');
  };

  const handleExitDomain = () => {
    exitDomain();
    navigate('/business-domain');
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '个人信息',
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
    },
  ];


  return (
    <AntLayout className="min-h-screen">
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={240}
        style={{
          background: token.colorBgContainer,
        }}
      >
        <div className="flex items-center justify-center h-16 border-b border-gray-200">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">ALT</span>
            </div>
            {!collapsed && (
              <span className="text-lg font-semibold text-gray-800">智能化评测平台</span>
            )}
          </div>
        </div>

        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          defaultOpenKeys={['domain-management']}
          items={menuItems}
          onClick={handleMenuClick}
          style={{
            borderRight: 0,
            height: 'calc(100vh - 64px)',
            overflowY: 'auto',
          }}
        />
      </Sider>

      <AntLayout>
        <Header
          style={{
            padding: '0 24px',
            background: token.colorBgContainer,
            borderBottom: `1px solid ${token.colorBorderSecondary}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div className="flex items-center space-x-4">
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{
                fontSize: '16px',
                width: 64,
                height: 64,
              }}
            />

            {/* 面包屑导航 */}
            {(currentDomain || currentScenario) && (
              <Space size="middle">
                {currentDomain && (
                  <Space>
                    <span className="text-gray-600">当前项目空间：</span>
                    <span className="font-medium text-blue-600">{currentDomain.domainName}</span>
                    <Button
                      type="link"
                      size="small"
                      icon={<RollbackOutlined />}
                      onClick={handleExitDomain}
                    >
                      退出空间
                    </Button>
                  </Space>
                )}
                {currentScenario && (
                  <Space>
                    <span className="text-gray-400">|</span>
                    <span className="text-gray-600">当前业务场景：</span>
                    <span className="font-medium text-green-600">{currentScenario.scenarioName}</span>
                    <Button
                      type="link"
                      size="small"
                      icon={<RollbackOutlined />}
                      onClick={handleExitScenario}
                    >
                      退出场景
                    </Button>
                  </Space>
                )}
              </Space>
            )}
          </div>

          <div className="flex items-center space-x-4">
            <Dropdown
              menu={{
                items: userMenuItems,
                onClick: handleUserMenuClick,
              }}
              placement="bottomRight"
            >
              <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-50 px-3 py-2 rounded-lg transition-colors">
                <Avatar
                  size="small"
                  src={currentUser.headImg}
                  icon={!currentUser.headImg && <UserOutlined />}
                />
                <span className="text-gray-700 font-medium">{currentUser.name}</span>
              </div>
            </Dropdown>
          </div>
        </Header>

        <Content
          style={{
            background: '#f5f5f5',
            minHeight: 'calc(100vh - 64px)',
            overflow: 'auto',
          }}
        >
          {children}
        </Content>
      </AntLayout>
    </AntLayout>
  );
}

export default Layout;